module.exports = __webpack_public_path__ + "physical___E9bA4.svg";